// AUTO-GENERATED village/town content pages (no fare, quote-on-request).
export const VILLAGE_LOCATIONS = [
  { slug: "winterthur", name: "Winterthur" },
  { slug: "kloten", name: "Kloten" },
  { slug: "buelach", name: "Bülach" },
  { slug: "dietikon", name: "Dietikon" },
  { slug: "wetzikon", name: "Wetzikon" },
  { slug: "horgen", name: "Horgen" },
  { slug: "meilen", name: "Meilen" },
  { slug: "uster", name: "Uster" },
  { slug: "duebendorf", name: "Dübendorf" },
  { slug: "opfikon", name: "Opfikon" },
  { slug: "schlieren", name: "Schlieren" },
  { slug: "adliswil", name: "Adliswil" },
  { slug: "thalwil", name: "Thalwil" },
  { slug: "volketswil", name: "Volketswil" },
  { slug: "regensdorf", name: "Regensdorf" },
  { slug: "wallisellen", name: "Wallisellen" },
  { slug: "staefa", name: "Stäfa" },
  { slug: "zollikon", name: "Zollikon" },
  { slug: "kilchberg", name: "Kilchberg" },
  { slug: "rueti", name: "Rüti" },
  { slug: "pfaeffikon-zh", name: "Pfäffikon ZH" },
  { slug: "effretikon", name: "Effretikon" },
  { slug: "bassersdorf", name: "Bassersdorf" },
  { slug: "hinwil", name: "Hinwil" },
  { slug: "maennedorf", name: "Männedorf" },
  { slug: "kuesnacht", name: "Küsnacht" },
  { slug: "waedenswil", name: "Wädenswil" },
  { slug: "richterswil", name: "Richterswil" },
  { slug: "oberrieden", name: "Oberrieden" },
  { slug: "erlenbach", name: "Erlenbach" },
  { slug: "zumikon", name: "Zumikon" },
  { slug: "greifensee", name: "Greifensee" },
  { slug: "faellanden", name: "Fällanden" },
  { slug: "maur", name: "Maur" },
  { slug: "egg", name: "Egg" },
  { slug: "gossau-zh", name: "Gossau ZH" },
  { slug: "grueningen", name: "Grüningen" },
  { slug: "bubikon", name: "Bubikon" },
  { slug: "wald", name: "Wald" },
  { slug: "turbenthal", name: "Turbenthal" },
  { slug: "elgg", name: "Elgg" },
  { slug: "neftenbach", name: "Neftenbach" },
  { slug: "pfungen", name: "Pfungen" },
  { slug: "andelfingen", name: "Andelfingen" },
  { slug: "feuerthalen", name: "Feuerthalen" },
  { slug: "flaach", name: "Flaach" },
  { slug: "rafz", name: "Rafz" },
  { slug: "embrach", name: "Embrach" },
  { slug: "rorbas", name: "Rorbas" },
  { slug: "freienstein", name: "Freienstein" },
  { slug: "glattfelden", name: "Glattfelden" },
  { slug: "stadel", name: "Stadel" },
  { slug: "niederglatt", name: "Niederglatt" },
  { slug: "oberglatt", name: "Oberglatt" },
  { slug: "niederhasli", name: "Niederhasli" },
  { slug: "oberhasli", name: "Oberhasli" },
  { slug: "daellikon", name: "Dällikon" },
  { slug: "daenikon", name: "Dänikon" },
  { slug: "otelfingen", name: "Otelfingen" },
  { slug: "boppelsen", name: "Boppelsen" },
  { slug: "uitikon", name: "Uitikon" },
  { slug: "birmensdorf", name: "Birmensdorf" },
  { slug: "wettswil", name: "Wettswil" },
  { slug: "bonstetten", name: "Bonstetten" },
  { slug: "stallikon", name: "Stallikon" },
  { slug: "affoltern-am-albis", name: "Affoltern am Albis" },
  { slug: "hedingen", name: "Hedingen" },
  { slug: "ottenbach", name: "Ottenbach" },
  { slug: "obfelden", name: "Obfelden" },
  { slug: "mettmenstetten", name: "Mettmenstetten" },
  { slug: "knonau", name: "Knonau" },
  { slug: "herrliberg", name: "Herrliberg" },
  { slug: "langnau-am-albis", name: "Langnau am Albis" },
  { slug: "rueschlikon", name: "Rüschlikon" },
  { slug: "zug", name: "Zug" },
  { slug: "baar", name: "Baar" },
  { slug: "cham", name: "Cham" },
  { slug: "steinhausen", name: "Steinhausen" },
  { slug: "rotkreuz", name: "Rotkreuz" },
  { slug: "oberaegeri", name: "Oberägeri" },
  { slug: "unteraegeri", name: "Unterägeri" },
  { slug: "walchwil", name: "Walchwil" },
  { slug: "kriens", name: "Kriens" },
  { slug: "emmen", name: "Emmen" },
  { slug: "ebikon", name: "Ebikon" },
  { slug: "horw", name: "Horw" },
  { slug: "sursee", name: "Sursee" },
  { slug: "hochdorf", name: "Hochdorf" },
  { slug: "schwyz", name: "Schwyz" },
  { slug: "brunnen", name: "Brunnen" },
  { slug: "einsiedeln", name: "Einsiedeln" },
  { slug: "kuessnacht-am-rigi", name: "Küssnacht am Rigi" },
  { slug: "arth", name: "Arth" },
  { slug: "goldau", name: "Goldau" },
  { slug: "pfaeffikon-sz", name: "Pfäffikon SZ" },
  { slug: "lachen", name: "Lachen" },
  { slug: "wollerau", name: "Wollerau" },
  { slug: "freienbach", name: "Freienbach" },
  { slug: "altendorf", name: "Altendorf" },
  { slug: "altdorf", name: "Altdorf" },
  { slug: "erstfeld", name: "Erstfeld" },
  { slug: "stans", name: "Stans" },
  { slug: "hergiswil", name: "Hergiswil" },
  { slug: "sarnen", name: "Sarnen" },
  { slug: "wettingen", name: "Wettingen" },
  { slug: "aarau", name: "Aarau" },
  { slug: "wohlen", name: "Wohlen" },
  { slug: "lenzburg", name: "Lenzburg" },
  { slug: "brugg", name: "Brugg" },
  { slug: "zofingen", name: "Zofingen" },
  { slug: "rheinfelden", name: "Rheinfelden" },
  { slug: "spreitenbach", name: "Spreitenbach" },
  { slug: "wuerenlos", name: "Würenlos" },
  { slug: "neuenhof", name: "Neuenhof" },
  { slug: "moehlin", name: "Möhlin" },
  { slug: "frick", name: "Frick" },
  { slug: "bad-zurzach", name: "Bad Zurzach" },
  { slug: "kaiseraugst", name: "Kaiseraugst" },
  { slug: "suhr", name: "Suhr" },
  { slug: "buchs-ag", name: "Buchs AG" },
  { slug: "solothurn", name: "Solothurn" },
  { slug: "olten", name: "Olten" },
  { slug: "grenchen", name: "Grenchen" },
  { slug: "zuchwil", name: "Zuchwil" },
  { slug: "daeniken", name: "Däniken" },
  { slug: "schoenenwerd", name: "Schönenwerd" },
  { slug: "riehen", name: "Riehen" },
  { slug: "allschwil", name: "Allschwil" },
  { slug: "muttenz", name: "Muttenz" },
  { slug: "pratteln", name: "Pratteln" },
  { slug: "liestal", name: "Liestal" },
  { slug: "binningen", name: "Binningen" },
  { slug: "thun", name: "Thun" },
  { slug: "koeniz", name: "Köniz" },
  { slug: "ostermundigen", name: "Ostermundigen" },
  { slug: "burgdorf", name: "Burgdorf" },
  { slug: "langenthal", name: "Langenthal" },
  { slug: "biel", name: "Biel" },
  { slug: "lyss", name: "Lyss" },
  { slug: "spiez", name: "Spiez" },
  { slug: "steffisburg", name: "Steffisburg" },
  { slug: "st-gallen", name: "St. Gallen" },
  { slug: "gossau-sg", name: "Gossau SG" },
  { slug: "wil", name: "Wil" },
  { slug: "uzwil", name: "Uzwil" },
  { slug: "altstaetten", name: "Altstätten" },
  { slug: "buchs-sg", name: "Buchs SG" },
  { slug: "sargans", name: "Sargans" },
  { slug: "wattwil", name: "Wattwil" },
  { slug: "rapperswil", name: "Rapperswil" },
  { slug: "jona", name: "Jona" },
  { slug: "frauenfeld", name: "Frauenfeld" },
  { slug: "kreuzlingen", name: "Kreuzlingen" },
  { slug: "amriswil", name: "Amriswil" },
  { slug: "arbon", name: "Arbon" },
  { slug: "romanshorn", name: "Romanshorn" },
  { slug: "weinfelden", name: "Weinfelden" },
  { slug: "schaffhausen", name: "Schaffhausen" },
  { slug: "neuhausen", name: "Neuhausen" },
  { slug: "glarus", name: "Glarus" },
  { slug: "naefels", name: "Näfels" },
  { slug: "herisau", name: "Herisau" },
  { slug: "lauterbrunnen", name: "Lauterbrunnen" },
  { slug: "wengen", name: "Wengen" },
  { slug: "muerren", name: "Mürren" },
  { slug: "pontresina", name: "Pontresina" },
  { slug: "scuol", name: "Scuol" },
  { slug: "leysin", name: "Leysin" },
  { slug: "champery", name: "Champéry" },
  { slug: "taesch", name: "Täsch" },
  { slug: "falera", name: "Falera" },
  { slug: "laax", name: "Laax" },
  { slug: "bellinzona", name: "Bellinzona" },
  { slug: "mendrisio", name: "Mendrisio" },
  { slug: "fribourg", name: "Fribourg" },
  { slug: "neuchatel", name: "Neuchâtel" },
  { slug: "martigny", name: "Martigny" },
  { slug: "vevey", name: "Vevey" },
  { slug: "nyon", name: "Nyon" },
  { slug: "yverdon", name: "Yverdon" },
];
